export default __webpack_public_path__ + "static/media/LabUpload.6b97a7d3.svg";